<h1>{{ 'SIGNUP.PRICING' | translate }}: {{ getPricing() }} {{ getCurrency() }}</h1>
